import React, { Component } from 'react';
import { Checkbox, Select, TextField, } from '@shopify/polaris';
import { CsValidationContext } from "./csValidationForm";

// import CsAutocomplete from "../../../../Shared/components/csAutocomplete";


//input type
const INPUT_CSVALIDATION_ITEM = -1;
const INPUT_UNKNOWN = 0;
const INPUT_CHECKBOX = 1;
const INPUT_EMAIL = 2;
const INPUT_NORMAL = 3;
const INPUT_SELECT = 4;
const INPUT_CsAutoComplete = 5;

//rule type
const RULE_REQUIRED = 1;
const RULE_PATTERN = 2;
const RULE_MAXLENGTH = 3;
const RULE_MINLENGTH = 4;
const RULE_EMAIL = 5;
const RULE_STRING = 6;
const RULE_NUMBER = 7;
const RULE_FLOAT = 8;
const RULE_MIN = 9;
const RULE_MAX = 10;
const RULE_URL = 11;
const RULE_URL_OPTIONAL_PROTOCOL = 12;
const RULE_PHONE_NUMBER = 13;
const RULE_EU_VAT_NUMBER = 14;

const RuleMap = {
    required: RULE_REQUIRED,
    pattern: RULE_PATTERN,
    maxlength: RULE_MAXLENGTH,
    minlength: RULE_MINLENGTH,
    email: RULE_EMAIL,
    number: RULE_NUMBER,
    string: RULE_STRING,
    float: RULE_FLOAT,
    max: RULE_MAX,
    min: RULE_MIN,
    website: RULE_URL,
    websiteWtProtocol: RULE_URL_OPTIONAL_PROTOCOL,
    phone: RULE_PHONE_NUMBER,
    eu_vat_number: RULE_EU_VAT_NUMBER,
};

class CsValidationItem extends Component {
    static defaultProps = {
        rule: "",
        title: ""
    }

    render() {
        return <React.Fragment/>
    }
}


class CsValidation extends Component {

    static contextType = CsValidationContext;
    static Item = CsValidationItem;

    static defaultProps = {
        dynamicRules: false,
    }

    constructor(props) {
        super(props);
        this.rules = [];
        this.state = {
            errorFlag: false,
            errorIndex: 0,
            errorMessage: "",
        };
    }

    componentDidMount() {
        this.initRules();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.dynamicRules) {
            // Reset the rules after each render for dynamic validator
            this.initRules();

            // Reset error if there is no rule left
            if (!this.rules.length && this.state.errorFlag) {
                this.setState({ errorFlag: false, errorMessage: "", errorIndex: 0 });
            }
        }
    }

    initRules = () => {
        // Add myself to parent collector form
        const {addValidator} = this.context;
        addValidator(this);

        // Read children to collect rules
        this.rules = [];
        let children = [];
        if (this.props.children.length === undefined) {
            children.push(this.props.children);
        } else {
            children = this.props.children;
        }
        // console.log("componentDidMount: children", children);
        for (const child of children) {
            // todo: Can check (child is CsValidationItem)?
            if (child && child.props.rule && child.props.title) {
                this.addValidationRule(child.props.rule, child.props.title);
            }
        }
    }

    addValidationRule = (rule, title) => {
        // console.log(rule + ":" + title);
        rule = rule.toLowerCase();
        if (RuleMap[rule]) {
            this.rules.push({rule: RuleMap[rule], title: title});
        }
    }

    // Remove error as long as change
    componentWillReceiveProps(nextProps, nextContext) {
        if (this.state.errorFlag) {
            let oldValue = this.getValue(this.props);
            let nextValue = this.getValue(nextProps);
            if (oldValue !== nextValue) {
                this.setState({ errorFlag: false, errorMessage: "", errorIndex: 0 });
            }
        }
    }

    componentWillUnmount() {
        const {removeValidator} = this.context;
        removeValidator(this);
    }

    doValidation = () => {
        if (this.props.children === undefined) {
            console.log("Empty object");
            return true;
        }
        let children = [];
        if (this.props.children.length === undefined) {
            children.push(this.props.children);
        } else {
            children = this.props.children;
        }

        // console.log("doValidation: " + children.length);
        let index = 0;
        let errorMsg;
        for (const child of children) {
            index++;
            errorMsg = this.validate(child);
            if (errorMsg !== "") {
                this.setState({errorFlag: true, errorMessage: errorMsg, errorIndex: index});
                return false;
            }
        }
        if (this.state.errorFlag) {
            this.setState({errorFlag: false, errorMessage: "", errorIndex: 0});
        }
        return true;
    }

    render() {
        const {realtime, doValidatePrevEls, lastChildIsValidator, getLastValidator} = this.context;
        let children = this.props.children;
        let index = 0;
        let additionalProps = {};

        return React.Children.map(children, child => {
            index++;
            if (!child) {
                return '';
            }
  
            if (realtime && !child.props.onFocus) {
                if (!child.props.onFocus) {
                    additionalProps.onFocus = () => doValidatePrevEls(this);
                }
                if (lastChildIsValidator && getLastValidator() === this && !child.props.onBlur) {
                    additionalProps.onBlur = this.doValidation;
                }
            }
            
            if (index === this.state.errorIndex && this.state.errorFlag && this.state.errorMessage !== "") {
                return React.cloneElement(child, { error: this.state.errorMessage, ...additionalProps });
            } else {
                return React.cloneElement(child, { ...additionalProps });
            }
          });

        // if (this.state.errorFlag && this.state.errorMessage !== "") {
        //     // let children = this.props.children;
        //     // console.log("render: add error: ", this.state.errorIndex);
        //     //
        //     // for(let i in this.props.children) {
        //     //     console.log("render: child", i);
        //     //     if( i == this.state.errorIndex ) {
        //     //         this.props.children[i].error = this.state.errorMessage;
        //     //     }
        //     // }
        //     // let children = this.props.children;
        //     // let index = 0;
        //     // const childrenWithProps = React.Children.map(children, child => {
        //     //         index++;
        //     //         if (index === this.state.errorIndex) {
        //     //             return React.cloneElement(child, {error: this.state.errorMessage})
        //     //         } else {
        //     //             return child;
        //     //         }
        //     //     }
        //     // );
        //     let children = this.props.children;
        //     let index = 0;
        //     const childrenWithProps = React.Children.map(children, child => {
        //             index++;
        //             if (index === this.state.errorIndex) {
        //                 return React.cloneElement(child, {error: this.state.errorMessage})
        //             } else {
        //                 return child;
        //             }
        //         }
        //     );
        //     return (
        //         <React.Fragment>
        //             {childrenWithProps}
        //         </React.Fragment>
        //     );
        // }
        // return (
        //     <React.Fragment>
        //         {this.props.children}
        //     </React.Fragment>
        // );
    }

    //following will be updated.

    getInputType = (obj) => {
        switch (obj.type) {
            case Checkbox:
                //console.log("input type: checkbox");
                return INPUT_CHECKBOX;
            case TextField: {
                if (obj.props.type !== undefined && obj.props.type === "email")
                    return INPUT_EMAIL;

                return INPUT_NORMAL;
            }
            case Select:
                return INPUT_SELECT;
            // case CsAutocomplete:
            //     return INPUT_CsAutoComplete;
            case CsValidationItem:
                return INPUT_CSVALIDATION_ITEM;        
            default:
                console.log("getInputType: unknown", obj, obj.props);
                return INPUT_UNKNOWN;
        }
    }
    getInputValue = (obj, type) => {
        switch (type) {
            case INPUT_CHECKBOX: {
                return obj.props.checked === undefined ? 0 : obj.props.checked;
            }
            case INPUT_EMAIL:
            case INPUT_NORMAL:
            case INPUT_SELECT: {
                return obj.props.value === undefined ? "" : obj.props.value;
            }
            case INPUT_CsAutoComplete: {
                return obj.props.selected === undefined ? "" : obj.props.selected;
            }
            default:
                return 0;
        }
    }

    getValue(props) {
        let inputType;
        let inputValue;
        if( !props.children )
            return null;
        for (const obj of props.children) {
            if (!obj) {
                continue;
            }
            inputType = this.getInputType(obj);
            if (inputType === INPUT_UNKNOWN || inputType === INPUT_CSVALIDATION_ITEM)
                continue;
            inputValue = this.getInputValue(obj, inputType);
            return inputValue;
        }
        return null;
    }

    validate = (obj) => {
        let inputType;
        let inputValue;
        if (!obj) {
            return "";
        }
        inputType = this.getInputType(obj);
        if (inputType === INPUT_UNKNOWN || inputType === INPUT_CSVALIDATION_ITEM)
            return "";
        inputValue = this.getInputValue(obj, inputType);

        // console.log(this.rules);
        for (const rule of this.rules) {
            // console.log(`${rule.rule}  ${inputType} ${inputValue}`);
            if (checkRule(rule.rule, inputType, inputValue, obj) === false) {
                return rule.title;
            }
        }
        return "";
    }
}

function matchRegexp(value, regexp) {
    const validationRegexp = regexp instanceof RegExp ? regexp : new RegExp(regexp);
    return validationRegexp.test(value);
}

function checkRule(rule, ...input) {
    switch (rule) {
        case RULE_REQUIRED:
            return checkRequire(...input);
        case RULE_MINLENGTH:
            return checkMinlength(...input);
        case RULE_MAXLENGTH:
            return checkMaxlength(...input);
        case RULE_EMAIL:
            return checkEmail(...input);
        case RULE_URL:
            return checkUrl(...input);
      case RULE_URL_OPTIONAL_PROTOCOL:
            return checkUrlWithoutProtocol(...input);
        case RULE_PHONE_NUMBER:
            return checkPhoneNumber(...input);
        case RULE_PATTERN:
            return checkPattern(...input);
        case RULE_FLOAT:
            return checkFloat(...input);
        case RULE_NUMBER:
            return checkNumber(...input);
        case RULE_STRING:
            return checkString(...input);
        case RULE_MIN:
            return checkMin(...input);
        case RULE_MAX:
            return checkMax(...input);
        case RULE_EU_VAT_NUMBER:
            return checkEuVatNumber(...input);
        default:
            console.log("checkRule Unknown!!!");
            return false;
    }
}

function checkRequire(type, value, obj) {
    return !!value;
}

function checkMinlength(type, value, obj) {
    if (obj.props.minLength === undefined)
        return true;
    if (typeof (value) !== 'string') {
        return false;
    }
    return value.length >= parseInt(obj.props.minLength, 10);
}

function checkMaxlength(type, value, obj) {
    if (obj.props.maxLength === undefined)
        return true;
    if (typeof (value) !== 'string') {
        return false;
    }
    return value.length <= parseInt(obj.props.maxLength, 10);
}

function checkMin(type, value, obj) {
    if (obj.props.min === undefined) {
        return true;
    }

    return parseInt(value, 10) >= parseInt(obj.props.min, 10);
}


function checkMax(type, value, obj) {
    if (obj.props.max === undefined)
        return true;

    return parseInt(value, 10) <= parseInt(obj.props.max, 10);
}

function checkEmail(type, value, obj) {
    if (value === "")
        return true;

    return matchRegexp(value, /^((([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i);
}

function checkUrl(type, value) {
    return value === '' || 
        matchRegexp(value, /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i);
}

function checkUrlWithoutProtocol(type, value) {
    return value === '' ||
      matchRegexp(value, /^(?:(?:(?:(?:https?|ftp):)?\/\/)?)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i);  
}

function checkPhoneNumber(type, value) {
    return value === '' ||
        matchRegexp(value, /^[+]?[(]?[0-9]{2,3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im);
}

function checkPattern(type, value, obj) {
    if (value === "")
        return true;
    let pattern = obj.props.pattern;
    if (pattern === undefined)
        return true;

    return matchRegexp(value, pattern);
}

function checkNumber(type, value, obj) {
    return matchRegexp(value, /^-?[0-9]\d*(\d+)?$/i);
}

function checkFloat(type, value, obj) {
    return matchRegexp(value, /^(?:[1-9]\d*|0)?(?:\.\d+)?$/i);
}

function checkString(type, value, obj) {
    return (typeof value === 'string' || value instanceof String);
}

function checkEuVatNumber(type, value) {
    return matchRegexp(value, /^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$/);
}

export default CsValidation;
